import { Link } from 'react-router'

import { strings } from '@/lib/strings'

export function LandingPage() {
  return (
    <section className="mx-auto max-w-2xl py-10 text-center">
      <h1 className="text-3xl font-semibold tracking-tight sm:text-4xl">{strings.landing.title}</h1>
      <p className="mt-4 text-lg text-muted">{strings.landing.subtitle}</p>

      <Link
        to="/tasks"
        className="mt-8 inline-block rounded-lg bg-accent px-5 py-2.5 font-medium text-accent-fg"
      >
        {strings.landing.cta}
      </Link>

      <ul className="mt-10 grid gap-3 text-left sm:grid-cols-3">
        {strings.landing.features.map((feature) => (
          <li key={feature} className="rounded-lg border border-border bg-surface p-4 text-sm">
            {feature}
          </li>
        ))}
      </ul>
    </section>
  )
}
